enum ControlIconType {
  CHEVRON = 'chevron',
  ARITH = 'arithmetic',
}

enum KeyConstants {
  ENTER = 'Enter',
  SPACE = 'Space',
}

enum FontSize {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
}

export { ControlIconType, KeyConstants, FontSize };
